import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {environment} from '../../../environments/environment';
import { IResponse } from 'projects/lib-ui/src/shared/interfaces/response';
import { IPartialUnit } from 'projects/lib-ui/src/shared/interfaces/unit';

@Injectable({
  providedIn: 'root',
})
export class UnitPollService {
  private readonly URI_API = environment.URLAPI + 'Branch';

  constructor(
    private readonly httpClient: HttpClient
  ) {
  }

  getUnitPoll(searchText: string): Observable<IResponse<IPartialUnit>> {
    return this.httpClient
      .get<IResponse<IPartialUnit>>(
        `${this.URI_API}/short-branch/${searchText}`
      )
      .pipe(map((response) => {
          if (response.data) {
            response.data = {
              ...response.data,
              pollDishReservationId: response.data.pollDishReservationId ?? '',
            }
          }
          return response
        }),
        catchError((error) => {
          console.error('Error fetching unit poll:', error);
          return of({
            data: null,
            success: false,
            message: 'Error fetching unit poll',
          } as IResponse<IPartialUnit>);
        })
      );
  }
}
